module.exports = __webpack_public_path__ + "img/supralift-topseller-black.c433a5ee.png";